import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function AnimatedStatCard({
  value,
  to,
  label,
  desc,
  sdesc,
  isRange = false,
  src,
}) {
  const counterRef = useRef(null);

  useEffect(() => {
    if (!counterRef.current) return;

    if (isRange && to) {
      const start = parseInt(value, 10);
      const end = parseInt(to, 10);

      if (isNaN(start) || isNaN(end)) return;

      let obj = { current: 0 };
      gsap.to(obj, {
        current: 1,
        duration: 2,
        ease: "power1.out",
        scrollTrigger: {
          trigger: counterRef.current,
          start: "top 80%",
          toggleActions: "play none none none",
        },
        onUpdate: () => {
          const from = Math.floor(start + (end - start) * obj.current);
          const toVal = Math.floor(end * obj.current);
          counterRef.current.innerText = `${from}~${toVal}`;
        },
        onComplete: () => {
          counterRef.current.innerText = `${start}~${end}`;
        },
      });
    } else {
      const target = parseInt(value, 10);
      if (isNaN(target)) return;

      gsap.fromTo(
        counterRef.current,
        { innerText: 0 },
        {
          innerText: target,
          duration: 2,
          ease: "power1.out",
          snap: { innerText: 1 },
          scrollTrigger: {
            trigger: counterRef.current,
            start: "top 80%",
            toggleActions: "play none none none",
          },
          onUpdate: () => {
            const el = counterRef.current;
            const currentValue = parseFloat(el.innerText);
            if (!isNaN(currentValue)) {
              el.innerText = Math.floor(currentValue).toString();
            }
          },
          onComplete: () => {
            counterRef.current.innerText = `${target}`;
          },
        }
      );
    }
  }, [value, to, isRange]);

  return (
    <div
      className="bg-gradient-to-tr from-[#030905] to-[#030e01]
                 rounded-2xl shadow-sm py-16 px-2 text-center
                 h-full flex flex-col
                 border border-white/30"
    >
      <img src={src} alt={label} className=" w-14 h-14 mx-auto" />
      <div className="text-4xl text-white/90 font-semibold uppercase mt-8">
        <span ref={counterRef}></span>
        <span className="text-xl">{label}</span>
        <span className="text-2xl">{!isRange && "+"}</span>
      </div>
      <div className="text-xl text-gray-500 mt-8 ">{desc}</div>
      <div className="text-sm text-gray-500 ">{sdesc}</div>
    </div>
  );
}
